import {Backend} from './Backend'
import AppAuthToken from './AppAuthToken'
import AppBackend from './AppBackend'

export default function () {
  return Promise.resolve(AppBackend)
}



// WEBPACK FOOTER //
// ./src/App/Services/BackendFactory.js